(function() {

	$( document ).ready(function() {

		var myForm = document.getElementById( 'contact-form' );
		var form = $( '.form-contact-form' );
		myForm.addEventListener( 'submit', function( event ) {

			event.preventDefault();

			grecaptcha.ready(function() {
				grecaptcha.execute( '6Les66kUAAAAANyLrgkl7iuN4JUpNlB5upaMovI4', { action : 'submit' }).then(function( token ) {
					document.getElementById( 'g-recaptcha-response' ).value = token;
					$( '.form-contact-submit-button' ).css( 'background-color', '#ffffff' );
					$( '.form-contact-submit-button' ).html( 'Loading...' );

					$.ajax({
						url : $('#contact-form').attr( 'action' ),
						method : $('#contact-form').attr( 'method' ),
						data : $('#contact-form').serialize(),
						success : function( res ) {

							$( '#form-contact-first-name' ).val( '' );
							$( '#form-contact-last-name' ).val( '' );
							$( '#form-contact-email' ).val( '' );
							$( '.input-group', form ).css( "display", "none" );
							$( '.form-contact-submit' ).css( "display", "none" );
							$( '.form-newsletter-submit-button').css( 'background-color', '#D13239' );
							$( '.form-newsletter-submit-button').html( window.theme.contact.button );

							$( '.form-contact-message', form ).append( "<p>"+ window.theme.contact.success +"</p>" );

						},
						error : function( err ){

							$( '#form-contact-first-name' ).val( '' );
							$( '#form-contact-last-name' ).val( '' );
							$( '#form-contact-email' ).val( '' );
							$( '.input-group', form ).css( "display", "none" );
							$( '.form-contact-submit' ).css( "display", "none" );
							$( '.form-newsletter-submit-button').css( 'background-color', '#D13239');
							$( '.form-newsletter-submit-button').html('Contact Us');

							$( '.form-contact-message', form ).append( "<p>" + window.theme.contact.error + "</p>" );

						}
					});
				});
			});
		});


	});

})();
